/**
 * Letvogne.dk custom JavaScript (theme Focal).
 * 4 Nov 2026 (Henry's rule): 61 40 40 49 is ALWAYS a tel: link and e-mail addresses are ALWAYS mailto: links, everywhere on the site.
 */
(function () {
  var PHONE = /(\+45[\s ]?)?61[\s ]?40[\s ]?40[\s ]?49/g;
  var MAIL = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;
  var SKIP = { A: 1, SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, BUTTON: 1, NOSCRIPT: 1, TEMPLATE: 1 };

  function linkify(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        for (var p = n.parentNode; p && p !== root.parentNode; p = p.parentNode) {
          if (SKIP[p.nodeName] || (p.isContentEditable)) return NodeFilter.FILTER_REJECT;
        }
        PHONE.lastIndex = 0; MAIL.lastIndex = 0;
        return (PHONE.test(n.nodeValue) || MAIL.test(n.nodeValue)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var html = n.nodeValue
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(PHONE, function (m) { return '<a class="lv-tel" href="tel:+4561404049">' + m + '</a>'; })
        .replace(MAIL, function (m) { return '<a class="lv-mail" href="mailto:' + m + '">' + m + '</a>'; });
      var span = document.createElement('span');
      span.innerHTML = html;
      while (span.firstChild) n.parentNode.insertBefore(span.firstChild, n);
      n.parentNode.removeChild(n);
    });
  }

  function run() { linkify(document.body); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
})();

/* 4 Nov 2026: mark the Besked field when it has text, so the centred "Besked" label (custom.css) only shows while empty */
document.addEventListener('input', function (e) {
  var t = e.target;
  if (t && t.id === 'product-contact-form-message' && t.parentNode) t.parentNode.classList.toggle('lv-has-val', t.value.trim() !== '');
});
